import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import { TUTOR_ONBOARDING_API } from "../../../api/api";

import { Navbar, Container, Nav, Dropdown } from "react-bootstrap";
import { FaChevronDown, FaShieldAlt, FaCommentDots } from "react-icons/fa";

import Logo from "../../../assets/Skilledition-logo.png";
import pendingReviewIcon from "../../../assets/under-review-pending-icon.png";
import rejectedReviewIcon from "../../../assets/under-review-rejected-icon.svg";
import completedIcon from "../../../assets/check-circle-icon.png";

import { handleApiError } from "../../../utils/apiErrorHandler";

import "./TutorDashboardUnderReview.css";

const TutorDashboardUnderReview = () => {
  const navigate = useNavigate();
  const [onboardStatus, setOnboardStatus] = useState({
    status: "",
    reason: "",
  });

  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  const handleEditProfile = () => {
    navigate("/tutor-onboarding", { state: { step: 9 } });
  };

  const handleLogout = () => {
    // Clear stored data
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("userRole");
    // localStorage.removeItem("tutor_id");
    // localStorage.removeItem("demo_video_id");

    navigate("/signin");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      navigate("/signin");

      return;
    }



    const fetchOnboardStatus = async () => {
      try {
        const response = await axios.post(
          TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_GET_STATUS,
          { user_id: userId },
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          setOnboardStatus({
            status: data.data.status,
            reason: data.data.reject_reason || "",
            fullName: data.data.full_name || "",
          });
        } else {
          // Handles any 2xx response that is not as expected
          showErrorToast(data.message);
        }
      } catch (error) {
        console.error("Error fetching onboarding status:", error);
        // Server responded with non-2xx status (like 400, 500)

        // CHECK (expiry / invalid token)
        handleApiError(error, navigate, showErrorToast, "/signin");
      }
    };

    fetchOnboardStatus();
  }, [navigate]);

  // Dynamic content based on status
  let statusTitle = "Pending Admin Review";
  let statusMessage =
    "Your profile is currently being reviewed by the Skilledition Admin team.";

  if (onboardStatus.status?.toLowerCase() === "published") {
    statusTitle = "Application Approved";
    statusMessage =
      "Congratulations! You now have full access to the tutor dashboard.";
  } else if (onboardStatus.status?.toLowerCase() === "rejected") {
    statusTitle = "Application Rejected";
    statusMessage = (
      <>
        Your application has been rejected.{" "}
        <span style={{ fontWeight: 600 }}>Reason: {onboardStatus.reason}</span>
      </>
    );
  }

  return (
    <div className="tutor-dashboard-under-review">
      <Container>
        <Navbar className="tutor-onboarding-navbar">
          <Navbar.Brand>
            <img
              className="tutor-onboarding-logo"
              src={Logo}
              alt="Skill Edition Logo"
            />
          </Navbar.Brand>

          <Nav className="align-items-center">
            <Dropdown className="tutor-onboarding-profile-dropdown" align="end">
              <Dropdown.Toggle
                className="tutor-onboarding-profile-btn"
                id="dropdown-basic"
              >
                <div className="tutor-onboarding-profile-info">
                  <div className="tutor-onboarding-profile-icon">
                    {onboardStatus.fullName
                      ? onboardStatus.fullName
                          .split(" ")
                          .map((n) => n[0])
                          .join("")
                          .toUpperCase()
                      : "NA"}
                  </div>
                  <div className="tutor-onboarding-profile-text">
                    <span className="tutor-onboarding-profile-name">
                      {onboardStatus.fullName || "Tutor"}
                    </span>
                    <span className="tutor-onboarding-profile-role">Tutor</span>
                  </div>
                  <FaChevronDown className="tutor-onboarding-dropdown-arrow" />
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="tutor-onboarding-profile-menu">
                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar>
      </Container>

      <Container className="tutor-dashboard-under-review-content mt-2 mb-5">
        {/* Header with Title and Status */}
        <div className="tutor-dashboard-under-review-header mb-5">
          <div className="d-flex flex-column align-items-start gap-2">
            <h2 className="tutor-dashboard-under-review-title">
              Tutor Dashboard
            </h2>
            <span
              className={`tutor-dashboard-under-review-status ${
                onboardStatus.status?.toLowerCase() === "pending"
                  ? "tutor-dashboard-under-review-status-pending"
                  : onboardStatus.status?.toLowerCase() === "published"
                    ? "tutor-dashboard-under-review-status-published"
                    : "tutor-dashboard-under-review-status-reject"
              }`}
            >
              {statusTitle}
            </span>
          </div>

          <div className="tutor-dashboard-under-review-actions">
            {onboardStatus.status?.toLowerCase() === "rejected" && (
              <button
                className="tutor-dashboard-under-review-btn"
                onClick={handleEditProfile}
              >
                Edit Profile
              </button>
            )}
            {/* <button className="tutor-dashboard-under-review-btn">Logout</button> */}
          </div>
        </div>

        {/* Info box */}
        <div className="tutor-dashboard-under-review-box-shadow">
          <div
            className={`tutor-dashboard-under-review-info-box ${
              onboardStatus.status?.toLowerCase() === "pending"
                ? "info-pending"
                : onboardStatus.status?.toLowerCase() === "published"
                  ? "info-published"
                  : "info-reject"
            }`}
          >
            <img
              src={
                onboardStatus.status?.toLowerCase() === "pending"
                  ? pendingReviewIcon
                  : onboardStatus.status?.toLowerCase() === "published"
                    ? completedIcon
                    : rejectedReviewIcon
              }
              className="tutor-dashboard-under-review-info-icon"
              alt="review-icon"
            />
            <div className="tutor-dashboard-under-review-info-text">
              <strong>{statusTitle}</strong>
              <p>{statusMessage}</p>
            </div>
          </div>

          {/* Sub info box below the info box */}
          {(onboardStatus.status?.toLowerCase() === "pending" ||
            onboardStatus.status?.toLowerCase() === "rejected") && (
            <div className="tutor-dashboard-under-review-sub-info">
              <strong>
                {onboardStatus.status?.toLowerCase() === "pending"
                  ? "What happens next?"
                  : "Next Steps after Rejection"}
              </strong>
              <p>
                {onboardStatus.status?.toLowerCase() === "pending"
                  ? "Our admin team will verify your credentials, review your demo video, and assess your teaching expertise. This usually takes 24-48 hours."
                  : "Unfortunately, your application was rejected. Please review the reason above and try updating your profile or demo video."}
              </p>
            </div>
          )}

          {/* Review Process Timeline */}
          <div className="tutor-dashboard-under-review-timeline-section">
            <h6 className="tutor-dashboard-under-review-timeline-title">
              Review Process Timeline
            </h6>
            <ul className="tutor-dashboard-under-review-timeline-list">
              <li className="tutor-dashboard-under-review-timeline-item completed">
                <span className="tutor-dashboard-under-review-timeline-dot green"></span>
                <div>
                  <h6>Application Submitted</h6>
                  <p>Your application was received successfully</p>
                </div>
              </li>

              <li
                className={`tutor-dashboard-under-review-timeline-item ${
                  onboardStatus.status?.toLowerCase() === "pending"
                    ? "in-progress"
                    : onboardStatus.status?.toLowerCase() === "published"
                      ? "completed"
                      : "reject"
                }`}
              >
                <span
                  className={`tutor-dashboard-under-review-timeline-dot ${
                    onboardStatus.status?.toLowerCase() === "pending"
                      ? "orange"
                      : onboardStatus.status?.toLowerCase() === "published"
                        ? "green"
                        : "red"
                  }`}
                ></span>
                <div>
                  <h6>Profile Verification</h6>
                  <p>
                    {onboardStatus.status?.toLowerCase() === "pending"
                      ? "Admin team is reviewing your credentials and demo video"
                      : onboardStatus.status?.toLowerCase() === "published"
                        ? "Profile verified successfully"
                        : "Profile verification failed"}
                  </p>
                </div>
              </li>

              <li
                className={`tutor-dashboard-under-review-timeline-item ${
                  onboardStatus.status?.toLowerCase() === "published"
                    ? "completed"
                    : onboardStatus.status?.toLowerCase() === "rejected"
                      ? "reject"
                      : "pending"
                }`}
              >
                <span
                  className={`tutor-dashboard-under-review-timeline-dot ${
                    onboardStatus.status?.toLowerCase() === "published"
                      ? "green"
                      : onboardStatus.status?.toLowerCase() === "rejected"
                        ? "red"
                        : "grey"
                  }`}
                ></span>
                <div>
                  <h6>Admin Approval</h6>
                  <p>
                    {onboardStatus.status?.toLowerCase() === "published"
                      ? "Approved"
                      : onboardStatus.status?.toLowerCase() === "rejected"
                        ? "Rejected"
                        : "Awaiting final approval from admin"}
                  </p>
                </div>
              </li>

              <li
                className={`tutor-dashboard-under-review-timeline-item ${
                  onboardStatus.status?.toLowerCase() === "published"
                    ? "completed"
                    : onboardStatus.status?.toLowerCase() === "rejected"
                      ? "reject"
                      : "pending"
                }`}
              >
                <span
                  className={`tutor-dashboard-under-review-timeline-dot ${
                    onboardStatus.status?.toLowerCase() === "published"
                      ? "green"
                      : onboardStatus.status?.toLowerCase() === "rejected"
                        ? "red"
                        : "grey"
                  }`}
                ></span>

                <div>
                  <h6>Dashboard Access Granted</h6>
                  <p>
                    {onboardStatus.status?.toLowerCase() === "published"
                      ? "Full access to tutor features"
                      : onboardStatus.status?.toLowerCase() === "rejected"
                        ? "Dashboard access denied due to rejection"
                        : "Available after approval"}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Dashboard Overview cards */}
        <div className="tutor-dashboard-under-review-overview-section">
          <h6 className="tutor-dashboard-under-review-timeline-title">
            Dashboard Overview
          </h6>
          <div className="tutor-dashboard-under-review-cards-section">
            <div className="tutor-dashboard-under-review-card">
              <p className="tutor-dashboard-under-review-card-title">
                Total Courses
              </p>
              <p className="tutor-dashboard-under-review-card-value">--</p>
            </div>
            <div className="tutor-dashboard-under-review-card">
              <p className="tutor-dashboard-under-review-card-title">
                Active Students
              </p>
              <p className="tutor-dashboard-under-review-card-value">--</p>
            </div>
            <div className="tutor-dashboard-under-review-card">
              <p className="tutor-dashboard-under-review-card-title">
                Assignments
              </p>
              <p className="tutor-dashboard-under-review-card-value">--</p>
            </div>
          </div>

          {onboardStatus.status?.toLowerCase() !== "published" && (
            <div className="tutor-dashboard-under-review-locked-banner">
              <FaShieldAlt className="tutor-dashboard-under-review-locked-icon" />
              <h6>Dashboard Locked</h6>
              <p>Available after approval</p>
            </div>
          )}
        </div>

        <div className="tutor-dashboard-under-review-help-support-bar">
          <div className="tutor-dashboard-under-review-help-text">
            <FaCommentDots className="tutor-dashboard-under-review-help-icon" />
            <div>
              <h6 className="tutor-dashboard-under-review-help-title">
                Need help with your application?
              </h6>
              <p className="tutor-dashboard-under-review-help-para">
                Contact our support team for assistance
              </p>
            </div>
          </div>
          <button className="tutor-dashboard-under-review-contact-support-btn">
            Contact Support
          </button>
        </div>
      </Container>
    </div>
  );
};

export default TutorDashboardUnderReview;
